export const environment = {
    production: false,
    buildType: 'CCC' as const,
    proxyDevServerHost: null,
    locales: ['en', 'ua'],
    defaultLocale: 'en',
};
